import React from 'react'
import RadioField from './RadioField'
import './RadioField.css'

const BarStrip = ( { title =  "IT Service Providers", updateItcoApplicationsLevel = "" } ) => {

  const handleClickLevel = (e) => {
    //console.log("clicked level "+e.target.value)
    updateItcoApplicationsLevel(e.target.value)
  };

  return (
    <div className="bg-green-50 w-full flex items-center justify-between px-2 h-12">
      <div className="text-xs md:text-base lg:text-base px-5 text-[#AFC836]">
          {title}
      </div>
      <div className="flex items-center">
        <div className="uppercase text-xs px-2">{`status`}</div>
        <div className="px-5 flex flex-row items-center justify-center">
          {/* <RadioField label="CCL1"/>
          <RadioField label="CCL2"/>
          <RadioField label="CCL3"/> */}
          <div className="flex items-center mr-4 text-xs">
            <input id="radioAll" type="radio" name="radio" value="0" onClick={handleClickLevel} className="hidden" />
            <label htmlFor="radioAll" className="flex items-center cursor-pointer text-xs">
            <span className="w-5 h-5 inline-block mr-2 rounded-full border border-black flex-no-shrink"></span>
            {`All`}</label>
          </div>

          <div className="flex items-center mr-4 text-xs">
            <input id="radio1" type="radio" name="radio" value="1" onClick={handleClickLevel} className="hidden" />
            <label htmlFor="radio1" className="flex items-center cursor-pointer text-xs">
            <span className="w-5 h-5 inline-block mr-2 rounded-full border border-black flex-no-shrink"></span>
            {`CC1`}</label>
          </div>

          <div className="flex items-center mr-4 text-xs">
            <input id="radio2" type="radio" name="radio" value="2" onClick={handleClickLevel} className="hidden" />
            <label htmlFor="radio2" className="flex items-center cursor-pointer text-xs">
            <span className="w-5 h-5 inline-block mr-2 rounded-full border border-black flex-no-shrink"></span>
            {`CC2`}</label>
          </div>

          <div className="flex items-center mr-4 text-xs">
            <input id="radio3" type="radio" name="radio" value="3" onClick={handleClickLevel} className="hidden" />
            <label htmlFor="radio3" className="flex items-center cursor-pointer text-xs">
            <span className="w-5 h-5 inline-block mr-2 rounded-full border border-black flex-no-shrink"></span>
            {`CC3`}</label>
          </div>
        </div>
      </div>
    </div>
  )
}
export default BarStrip
